var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 76,
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.008 90.2422C101.785 91.8828 101.785 94.7539 100.008 96.3945C99.1875 97.2148 98.0938 97.625 97 97.625C95.7695 97.625 94.6758 97.2148 93.8555 96.3945L79.5 82.0391L65.0078 96.3945C64.1875 97.2148 63.0938 97.625 62 97.625C60.7695 97.625 59.6758 97.2148 58.8555 96.3945C57.0781 94.7539 57.0781 91.8828 58.8555 90.2422L73.2109 75.75L58.8555 61.3945C57.0781 59.7539 57.0781 56.8828 58.8555 55.2422C60.4961 53.4648 63.3672 53.4648 65.0078 55.2422L79.5 69.5977L93.8555 55.2422C95.4961 53.4648 98.3672 53.4648 100.008 55.2422C101.785 56.8828 101.785 59.7539 100.008 61.3945L85.6523 75.8867L100.008 90.2422Z",
    fill: "#F56565"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentX);
export default ForwardRef;